import SearchBar from './search-bar';

export default SearchBar;
